module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"reidaFilterTitle":"Report nach REIDA","type":{"NOT_CONSIDERED":"Nicht anwendbar","NOT_EXISTING":"Nicht-Bestandesliegenschaft","EXISTING_NOT_CONFORM":"Bestandesliegenschaft (fehlende Messdaten)","EXISTING_AND_CONFORM":"Bestandesliegenschaft (genügend Messdaten)"}}}')
  delete Component.options._Ctor
}
